import { Document, FlatDocumentSection } from 'services/DocumentService'
import DocumentsList from 'components/documents/DocumentsList'

interface SectionDocumentsListProps {
  aol?: string
  data: Array<
  FlatDocumentSection & {
    sections: Array<FlatDocumentSection & { documents: Document[] }>
  }
  >
  favourites?: Set<string>
}

export default function SectionsDocumentsList ({
  aol = 'corporate',
  data,
  favourites = new Set()
}: SectionDocumentsListProps): JSX.Element {
  return (
    <ul className='list-reset pa0 ma0'>
      {data.map(section => (
        <li key={section.id}>
          <h2 className='ma0 bg-precedents-blue white pv4 ph4 f5'>{section.title}</h2>
          {section.sections.map(subsection => (
            <div key={subsection.id} className='flex flex-wrap f6 bb bb-light-bluish-grey'>
              <h3 className='basis-100 ma0 bg-precedents-blue-10 black pv3 ph6 f5'>
                {subsection.title}
              </h3>
              <DocumentsList
                aol={aol}
                documents={subsection.documents}
                selectedDocuments={[]}
                pageId=''
                selectable={false}
                expanded
                favourites={favourites}
                rootId={section.id}
              />
            </div>
          ))}
        </li>
      ))}
    </ul>
  )
}
